import React, { useState, useEffect } from "react";
import {
  Container,
  ContainerView,
  TitlePage,
} from "../../components/Container";
import {
  baseCurrencyCode,
  validateDecimalSeparator,
  prefixCcySymbol,
  suffixCcySymbol,
} from "../../utils/Currency";
import NumberFormat from "react-number-format";
import { itemDetail, itemDetailMarket, animations, itemMove } from "../../services/app";
import { useApp } from "../../contexts";
import { useWindowSize } from "../../hook/useWindowSize";
import { ArrowDownIcon } from "../../components/Icons/ArrowDownIcon";
import { IconFemale } from "../../components/Icons/IconFemale";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { roundNumber } from "../../services/app";
import environment from "../../environment";
import Ar3DViewer from "../../components/Ar3dViewer";

export const TabPurchaseOption = {
  mall: "mall",
  app: "app",
  market: "market",
};

export const CharacterDetail = () => {
  const {
    T: t,
    user,
    setLoading,
    language,
    convertToLocalCurrency,
    formatLocalCurrency,
    getCurrency,
    setPrePosition,
    prePosition,
  } = useApp();
  const [tab, setTab] = useState(TabPurchaseOption.mall);
  const [searchParams] = useSearchParams();
  let { id } = useParams();
  const size = useWindowSize();
  const navigate = useNavigate();
  const back = () => {
    navigate(-1);
  }
  const [randomClass, setRandomClass] = useState("");
  const [animationOptions, setAnimationOptions] = useState([]);
  const [itemData, setItemData] = useState(null);
  const [imgInfo, setImageInfo] = useState({});
  const [amimationIds, setAnimationIds] = useState([]);
  const [price, setPrice] = useState(0);
  const [openProperties, setOpenProperties] = useState(true);
  const [idv2, setIdv2] = useState(null);

  useEffect(() => {
    const arr = Array.from({ length: 7 }, (_, i) => i + 1);
    const random = itemData?.id % 7;
    setRandomClass(`suzu-card-image-${arr[random]}`);
  }, [itemData]);

  useEffect(() => {
    loadData();
    if (!prePosition) {
      setPrePosition('character')
    }
  }, []);
  
  const loadData = async () => {
    setLoading(true);
    const result = await Promise.all([itemDetail(id), animations()]); ;
    setItemData(result[0]?.data?.data?.item || null);
    if (typeof result[0]?.data?.data?.item?.img_info == 'string') {
      setImageInfo(JSON.parse(result[0]?.data?.data?.item?.img_info));
    }else{
      setImageInfo(result[0]?.data?.data?.item?.img_info || null);
    }
    setAnimationOptions(result[1]?.data?.data?.data || []);
    loadItemV2(result[0]?.data?.data?.item?.token);  
    setLoading(false);
  };
  const loadItemV2 = (token) => {
    itemDetailMarket(token).then((res) => {
      const idv2 = res?.data?.data?.idV2 || null;
      if (idv2) setIdv2(idv2);
    });
  };
  useEffect(() => {
    if (itemData) {
      setPrice(
        convertToLocalCurrency(itemData.price, itemData.ccy, getCurrency())
      );
    }
  }, [itemData]);

  useEffect(() => {
    if (itemData && animationOptions?.length > 0) {
      const amimationIds = JSON.parse(itemData.animation_id || '[]')
      const list = [];
      if (amimationIds.length > 0 ) {
        for (let i = 0; i < amimationIds.length; i++) {
          const animationSelected = animationOptions.find((item) => item.id == amimationIds[i])
          let translateText = animationSelected?.name?.toLowerCase();
          list.push(translateText)
        }
      }
      setAnimationIds(list)
    }
  }, [itemData, animationOptions]);

  return (
    <Container>
      <ContainerView background="transparent">
        <div className="flex justify-start gap-3 items-center">
          <div onClick={() => back()}>
            <ArrowDownIcon className="rotate-90 w-[24px] h-[24px] cursor-pointer stroke-black" />
          </div>
          <TitlePage>{t("Item Detail")}</TitlePage>
        </div>
        <div className="flex flex-wrap lg:flex-nowrap justify-start items-start lg:gap-[50px] mt-[30px] xls:mt-[40px]">
          <div className="w-full lg:w-[48%] mb-[23px] lg:mb-[0]">
            <div className="item-detail-img-shadow max-h-[300px] w-full lg:max-h-none aspect-square lg:pt-[30px] lg:pb-[45px] rounded-[28px] bg-white">
              {imgInfo ? (
                <div
                  className={`w-full ${randomClass} rounded-[16px] lg:rounded-none h-full item-image-inner`}
                >
                  <Ar3DViewer
                    showZoom={false}
                    publicId={imgInfo?.public_id}
                    cloudinaryInfo={imgInfo}
                  />
                </div>
              ) : (
                <>
                  <div
                    className={`w-full ${randomClass} rounded-[16px] lg:rounded-none h-full item-image-inner
                    ${itemData?.purchase_source == "shopify" ? 'p-[0]': 'p-[40px]'}`}
                  >
                    <img
                      className={`w-full h-full ${
                        itemData?.purchase_source == "shopify"
                          ? "object-cover"
                          : "object-contain"
                      } `}
                      src={itemData?.img}
                      onContextMenu={(e) => e.preventDefault()}
                      alt=""
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="w-full lg:w-[48%]">
            <div className="bg-[#FFFFFF] rounded-[25px] lg:rounded-[40px] h-[100%]">
              <div className="px-[15px] lg:px-[24px] py-[20px] lg:py-[40px]">
                <div className="block-item-right-head pb-[20px] lg:pb-[32px] mb-[20px] lg:mb-[32px] border-b border-solid border-[#E0E0E0]">
                  <div className="flex justify-between items-start gap-[20px]">
                    <div className="text-[#000000] text-[24px] w-full truncate xls:text-[30px] 2xl:text-[34px] mb-[5px] font-semibold font-manrope">
                      {itemData?.name}
                    </div>
                    {price > 0 ? (
                      <div className="text-aia-red text-[24px] xls:text-[34px]  font-semibold font-manrope">
                        <NumberFormat
                          value={formatLocalCurrency(roundNumber(price, 2))}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={prefixCcySymbol(true, getCurrency())}
                          suffix={suffixCcySymbol(true, getCurrency())}
                          decimalScale={validateDecimalSeparator(
                            baseCurrencyCode(true, getCurrency())
                          )}
                        />
                      </div>
                    ) : itemData?.gift_type == 1 ? (
                      <p className="bg-[#F4F4F4] mt-[6px] text-black text-xs px-2  md:text-base md:px-4 py-1 rounded-[10px] whitespace-nowrap">
                        {t("title.subscription")}
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div>
                    <div className="flex justify-start gap-3 items-center">
                      <span
                        className={`rounded-[30px] px-[6px] text-[12px]/[18px]  xs:px-[10px] lg:px-[19px] py-[4px] lg:py-[3px]
                        lg:text-[12px]/[21px] xls:text-[13px]/[28px] tag-inapp `}
                      >
                        {t("In app")}
                      </span>
                      <span
                        className={`rounded-[30px] px-[6px] text-[12px]/[18px]  xs:px-[10px] lg:px-[19px] py-[4px] lg:py-[3px]
                        lg:text-[12px]/[21px] xls:text-[13px]/[28px] tag-inmarket`}
                      >
                        {t("In market")}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="properties-block">
                  <div className="flex justify-between items-center mb-[12px] lg:mb-[22px]">
                    <span className="text-black text-[22px]/[30px] font-bold font-manrope">
                      {t("Properties")}
                    </span>
                    <span onClick={() => setOpenProperties(!openProperties)}>
                      <svg
                        width="24"
                        className={`w-[16px] cursor-pointer ${
                          openProperties ? "rotate-180" : ""
                        }`}
                        height="14"
                        viewBox="0 0 24 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 2L12 12L22 2"
                          stroke="black"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  {openProperties && (
                    <>
                      <div className="flex items-center justify-between grow-1">
                        <span className="text-[14px] lg:text-[16px]">
                          {t("ID")}
                        </span>
                        <span className="h-[36px] lg:h-[40px] text-center text-[14px] lg:text-[16px] leading-[36px] lg:leading-[40px]">
                          #{itemData?.id}
                        </span>
                      </div>
                      <div className="flex items-start justify-between grow-1">
                        <span className="text-[14px] lg:text-[16px] capitalize">
                          {t("Animation included")}
                        </span>
                        <div className="flex justify-end items-center gap-3 flex-wrap max-w-[150px] xs:max-w-[50%]">
                          {amimationIds?.length > 0 && (
                            <>
                              {amimationIds.map((animationId) => {
                                return (
                                  <span
                                    key={animationId}
                                    className="h-[22px] lg:h-[22px] px-[12px] min-w-[52px] text-[12px] lg:text-[14px] 
                                  text-center leading-[24px] lg:leading-[24px]  bg-[#7070701a] rounded-[30px]"
                                  >
                                    {t(`title.${animationId}`)}
                                  </span>
                                );
                              })}
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
                {/* <div className="w-full mt-[32px]">
                  {itemData?.gift_type === 0 && (
                    <a
                      href={`${environment.MARKETPLACE_URL}/item-detail-3d/${idv2}`}
                      target="_blank"
                      rel="noreferrer"
                      className="w-full bg-black !text-white flex justify-center items-center 
                    rounded-[15px] px-[20px]  py-[9px] lg:py-[11px] text-[16px] xls:text-[20px] font-[500] mb-[15px]"
                      type="button"
                    >
                      {t("View on C2C market")}
                    </a>
                  )}
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </ContainerView>
    </Container>
  );
};
